import React from 'react'
import styled from 'styled-components'
import MaterialIcon from 'material-icons-react'
import { Col, Background, Container, Row, } from '../components'
import { useTranslation } from 'react-i18next'

const Outer = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 120px;

  h4 {
    font-size: 45px;
    font-weight: 900;
    line-height: 1.2;
    color: #b19961;
  }

  @media (max-width: 768px) {
    margin-top: 60px;

    h4 {
      font-size: 30px;
    }
  }
`
const TextLink = styled.a`
  text-decoration: none;  
  display: inline-block;
`


const Inner = styled.div`
  padding: 0 90px;

  p {
    color: #303b44;
  }

  font-size: 35px;

  @media (max-width: 768px) {
    padding: 0 20px;
    font-size: 20px;
  }
`

const Title = styled.h1`
  color: #ec1c24;
  font-size: 100px;
  margin: 0;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 50px;
  }
`

const Text = styled.p`
  font-weight: 300;
  font-size: 80px;
  margin: 0 0 0 10px;
  color: '#363535';

  @media (max-width: 768px) {
    font-size: 30px;
    margin: 0;
  }
`

const Text2 = styled.p`
  font-weight: 300;
  font-size: 40px;
  margin: 150px 0 0 50px;

  @media (max-width: 768px) {
    font-size: 20px;
    margin: 50px 0 0 10px;
  }
`

const Text3 = styled.p`
  font-weight: 300;
  font-size: 40px;
  margin: 0 50px;

  @media (max-width: 768px) {
    font-size: 20px;
    margin: 0 10px;
  }
`

const Home = () => {
  const { t } = useTranslation()
  const img_url = require('assets/first.jpg')

  return (
    <Container id='home'>
      <Background img={img_url}>
        <Col between>
          <Outer>
            <Inner>
              <Title>WINNER OPTIMIST</Title>
              <Text>{t('home.nameFits')}</Text>
            </Inner>
          </Outer>
          <Outer>
            <Inner>
              <Text2>{t('home.titre')}</Text2>
              <Text3>{t('home.countries')}</Text3>
            </Inner>
          </Outer>
         </Col>
      </Background>
    </Container>
  )
}

export default Home
